/*  ========================================================================
    # Scripts - Menu
    ========================================================================  */

const Menu = {
  cfg: {
    html: document.querySelector('html'),
    class: 'page-shifted',
    button: {
      open: document.getElementById('js-button-menu--open'),
      close: document.getElementById('js-button-menu--close')
    },
    preloader: document.querySelector('.c-preloader')
  },

  /**
   *
   */
  openMenu() {
    this.cfg.button.open.addEventListener('click', () => {
      if (this.cfg.html.classList.contains(this.cfg.class)) {
        //
      } else {
        this.cfg.html.classList.add(this.cfg.class);
      }
    });
  },

  /**
   *
   */
  closeMenu() {
    this.cfg.button.close.addEventListener('click', () => {
      if (this.cfg.html.classList.contains(this.cfg.class)) {
        this.cfg.html.classList.remove(this.cfg.class);
      } else {
        //
      }
    });

    this.cfg.preloader.addEventListener('click', () => {
      if (this.cfg.html.classList.contains(this.cfg.class)) {
        this.cfg.html.classList.remove(this.cfg.class);
      } else {
        //
      }
    });
  },

  /**
   * Initialize.
   */
  init() {
    this.openMenu();
    this.closeMenu();
  }
};

export default Menu;
